module.exports = __webpack_public_path__ + "img/138.6473e7d8.jpg";